<template>
  <div
    :class="[
      $style['spinner'],
      {[$style[`spinner--${size}`]]: size}
    ]" />
</template>
<script setup>
defineProps({
  size: {
    type: String,
    default: null
  }
})
</script>
<style lang="scss" module>
.spinner {
  border: 2px solid var(--grey-opacity);
  border-bottom: 2px solid var(--black-50-opacity);
  border-radius: 100%;
  width: calc(var(--spacing) * 3);
  height: calc(var(--spacing) * 3);
  position: relative;
  animation: spin 1s infinite;
  animation-timing-function: linear;
  will-change: transform;

  &--big {
    border-width: 3px;
    width:calc(var(--spacing ) * 5);
    height:calc(var(--spacing ) * 5);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
